import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

import BackButton from '@ts-core/components/BackButton';

const ToMainMenuButton = (props) => {
  const { noMargin, title } = props;

  const { courseId } = useParams();
  const intl = useIntl();
  const history = useHistory();

  const onGoBack = useCallback(() => {
    history.push(`/${courseId}/dashboard`);
  }, [history, courseId]);

  return (
    <BackButton
      onGoBack={onGoBack}
      noMargin={noMargin}
      title={title}
      subtitle={intl.formatMessage({ id: 'drawer.course.dashboard' })}
    />
  );
};

ToMainMenuButton.propTypes = {
  title: PropTypes.node,
  noMargin: PropTypes.bool,
};

ToMainMenuButton.defaultProps = {
  title: undefined,
  noMargin: false,
};

export default ToMainMenuButton;
